import { DotLegalMultiSelect } from "@dotlegal/dotlegal-ui-components";
import { useTranslation } from "../../localization/useTranslation.ts";
import { useSecurityMeasuresQuery } from "@common/hooks/useSelectableItemQueries.ts";

export interface SystemSecurityMeasuresCreationFieldProps {
    selectedIds: Array<string>;
    onChange: (ids: Array<string>) => void;
    errorText?: string;
    disabled: boolean;
}

function SystemSecurityMeasuresCreationField(props: SystemSecurityMeasuresCreationFieldProps) {
    const { translateString } = useTranslation();
    const { data, isLoading } = useSecurityMeasuresQuery(true, false);

    return (
        <DotLegalMultiSelect
            isLoading={isLoading}
            options={data}
            chosenOptions={props.selectedIds}
            onChange={props.onChange}
            placeholder={translateString("securityMeasures")}
            label={translateString("securityMeasures")}
            noOptionsLabel={translateString("noOptions")}
            disabled={props.disabled}
            errorText={props.errorText}
        />
    );
}

export default SystemSecurityMeasuresCreationField;
